import React, { memo } from "react";

interface BadgeIconProps extends React.SVGProps<SVGSVGElement> {
  isSolidFill?: boolean;
  strokeWidth?: number;
}

const BadgeIcon = memo(
  ({ isSolidFill = false, strokeWidth = 1.5, ...svgProps }: BadgeIconProps) => (
    <svg
      width="64"
      height="79"
      viewBox="0 0 26 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      // Important: Standard props must be passed here for style/className to work
      {...svgProps}
    >
      {!isSolidFill && (
        <defs>
          {/* Note: If you have multiple badges on one page, 
             you might need unique IDs for this gradient to avoid conflicts.
          */}
          <linearGradient
            id="badge-gradient"
            x1="5.49079"
            y1="1.35264"
            x2="21.0243"
            y2="26.3607"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="currentColor" stopOpacity="0" />
            <stop offset="0.271" stopColor="currentColor" stopOpacity="0" />
            <stop offset="0.464" stopColor="currentColor" stopOpacity="0.6" />
            <stop offset="0.664" stopColor="currentColor" stopOpacity="0" />
            <stop offset="1" stopColor="currentColor" stopOpacity="0" />
          </linearGradient>
        </defs>
      )}
      {/* Base white layer */}
      <path
        d="M3.99805 0.5H22.002C23.9338 0.500259 25.4997 2.06624 25.5 3.99805V21.8965C25.4999 23.102 24.8794 24.2228 23.8574 24.8623L15.1846 30.2881C14.0779 30.9804 12.6774 30.9995 11.5527 30.3369L2.22266 24.8408C1.15522 24.212 0.500055 23.0651 0.5 21.8262V3.99805C0.500256 2.06624 2.06624 0.500259 3.99805 0.5Z"
        fill="#fff"
      />
      {/* Gradient layer using currentColor */}
      <path
        d="M3.99805 0.5H22.002C23.9338 0.500259 25.4997 2.06624 25.5 3.99805V21.8965C25.4999 23.102 24.8794 24.2228 23.8574 24.8623L15.1846 30.2881C14.0779 30.9804 12.6774 30.9995 11.5527 30.3369L2.22266 24.8408C1.15522 24.212 0.500055 23.0651 0.5 21.8262V3.99805C0.500256 2.06624 2.06624 0.500259 3.99805 0.5Z"
        fill={isSolidFill ? "currentColor" : "url(#badge-gradient)"}
        fillOpacity={isSolidFill ? 1 : 0.1}
      />
      {/* Stroke layer using currentColor */}
      <path
        d="M3.99805 0.5H22.002C23.9338 0.500259 25.4997 2.06624 25.5 3.99805V21.8965C25.4999 23.102 24.8794 24.2228 23.8574 24.8623L15.1846 30.2881C14.0779 30.9804 12.6774 30.9995 11.5527 30.3369L2.22266 24.8408C1.15522 24.212 0.500055 23.0651 0.5 21.8262V3.99805C0.500256 2.06624 2.06624 0.500259 3.99805 0.5Z"
        stroke="currentColor"
        strokeWidth={strokeWidth}
      />
    </svg>
  )
);

export default BadgeIcon;
